<!--优惠券卡片-->
<template>
	<div class="coupons-card">
		<div class="title" v-if="type === 3">领取优惠券</div>
		<div class="title" v-if="type === 4">选择优惠券</div>
		<div class="content" :class="type === 4 ?'content1':''">
			<div
				class="list"
				:class="{
					grbg: type === 2, //过期灰色
					blbg: type != 2, //通用蓝色
					blbg2: (type === 3 && item.receiveStatus === '2'), //赢取完了
					noselect: item.usable === '1', //不可选
					selectbg: current === index, //当前选中的
				}"
				v-for="(item, index) in couponList"
				:key="index"
				@click="useCoupon(item, index)"
			>
				<div class="left">
					<div class="coupon-title">{{ item.name }}</div>
					<!-- <div class="coupon-rematk">{{ item.name }}</div> -->
					<div class="coupon-time" v-if="item.validStartTime">
						{{ showDate(item.validStartTime) }}至{{
							showDate(item.validEndTime)
						}}
					</div>
					<div class="coupon-type">{{ item.instructions }}</div>
				</div>
				<div class="right">
					<div class="coupon-price">￥{{ item.kimsPrice }}</div>
					<div class="coupon-price1 van-ellipsis">
						满{{ item.useConditions }}可用
					</div>
					<div class="btn" v-if="type === 3" @click="goPay(item)">
						{{ receiveStatusStr(item) }}
					</div>
					<div class="btn" v-if="type === 4 && item.usable === '1'">
						{{ '不可用' }}
					</div>
				</div>
			</div>
		</div>
		<van-empty v-if="couponList.length <= 0" description="暂无数据~" />
		<div class="no_btn" v-if="type === 4" @click="noPay">不使用优惠券</div>
		
	</div>
</template>

<script>
import { Notify } from 'vant'
import { parseTime } from '../utils'
import { getToken } from '../utils/auth.js'

export default {
	name: 'coupons-card',
	props: {
		// 0待使用，1使用了，2过期 3产品的优惠券 4产品下我的可用优惠券
		type: {
			type: Number,
			default() {
				return 0
			},
		},
		productList: {
			type: Array,
			default() {
				return []
			},
		},
		productType: {
			type: String,
			default() {
				return ''
			},
		},
	},
	data() {
		return {
			current: -1,
			couponList: [],
		}
	},
	mounted() {
		this.init()
	},
	computed: {
		showDate() {
			return function (date) {
				return parseTime(date, '{yyyy}-{mm}-{dd}')
			}
		},
		receiveStatusStr(){
			return function(item){
				if(item.receiveStatus === '0'){
					return '已领取'
				}else if(item.receiveStatus === '1'){
					return '领取'
				}else{
					return '已领完'
				}
			}
		}
	},
	methods: {
		init() {
			if (this.type <= 2) {
				// 我的优惠券
				this.getselfCouponsList()
			} else if (this.type == 3) {
				// 商品优惠券
				this.selectProductCouponsList()
			} else if (this.type == 4) {
				// 该商品我能使用的优惠券
				this.getProductAvaildCounpon()
			}
		},
		// 获取我的优惠券
		getselfCouponsList() {
			var param = {
				status: this.type,
			}
			this.$API.coupons
				.getselfCouponsList(param)
				.then((res) => {
					this.couponList = res.rows
				})
				.catch((err) => {})
		},
		// 产品的优惠券列表
		selectProductCouponsList() {
			var param = {
				productIds: this.productList,
				productType: this.productType,
				receiveChannel: 'h5',
			}
			this.$API.coupons
				.selectProductCouponsList(param)
				.then((res) => {
					this.couponList = res.data
				})
				.catch((err) => {})
		},
		// 产品对应我的的优惠券列表
		getProductAvaildCounpon() {
			var param = {
				productInfoList: this.productList,
				productType: this.productType,
				receiveChannel: 'h5',
			}
			this.$API.coupons
				.getProductAvaildCounpon(param)
				.then((res) => {
					this.couponList = res.data.filter(res=>{

							return res.status == '0'

					})
						.sort((a, b) => {
							const usable1 = parseInt(b.usable)
							const usable2 = parseInt(a.usable)

							const price1 = parseInt(b.kimsPrice)
							const price2 = parseInt(a.kimsPrice)
							if (usable1===usable2){
								return price1 - price2
							}
							return usable2 - usable1
						})

				})
				.catch((err) => {})
		},
		// 领取消费劵
		acquireActivityCoupons(item) {

			if (localStorage.getItem('flag') === 'true') {
				this.$router.push({ path: '/login' })
				return
			}
			const hasToken = getToken()
			if (!hasToken) {
				this.$router.push({ path: '/login' })
				return
			}
			const user = this.$store.state.userInfo_v2.user
			var param = {
				id: item.id,
				userName: user.userName || '',
				userId: user.userId || '',
				productIds: this.productList,
				receiveChannel: 'h5',
			}
			this.$API.coupons
				.acquireActivityCoupons(param)
				.then((res) => {

					this.init()
					Notify({ type: 'success', message: '领取成功' })
				})
				.catch((err) => {})
		},

		goPay(item) {
			if (item.receiveStatus === '1') {
				this.acquireActivityCoupons(item)
			}
		},
		useCoupon(item, index) {
			if (this.type === 4 && item.usable === '0') {
				this.current = index
				this.$emit('goPay', item)
			}
		},
		noPay(){
			this.$emit('noPay')
		}
	},
}
</script>

<style lang="scss" scoped>
.coupons-card {
	height: 100%;
	box-sizing: border-box;
	.title {
		color: #333;
		font-size: vw(28);
		text-align: center;
		margin: vw(30) 0;
	}
	.content {
		height: calc(100% - 80px);
		overflow-y: scroll;
		box-sizing: border-box;
	}

	.content1 {
		height: calc(100% - 140px);
		overflow-y: scroll;
		box-sizing: border-box;
	}

	.list {
		box-sizing: border-box;
		width: vw(690);
		height: vw(200);
		display: flex;
		margin: vw(30) auto 0;
		padding: vw(20);
		> div {
			display: flex;
			flex-direction: column;
			justify-content: space-around;
		}
		.left {
			flex: 1;
			.coupon-title {
				height: vw(45);
				line-height: vw(45);
				font-size: vw(32);
			}
			.coupon-time {
				font-size: vw(26);
			}
			.coupon-type {
				margin-right: vw(20);
				font-size: vw(26);
			}
		}
		.right {
			width: 30%;
			align-items: center;
			.coupon-price {
				height: vw(59);
				font-size: vw(42);
				color: #ff5232;
			}
			.coupon-price1 {
				font-size: vw(24);
			}
			.btn {
				font-size: vw(24);
			}
		}
	}

	.coupon-rematk {

				font-size: vw(24);
				color: #999
	}

	.rebg {
		background-image: url('../assets/market/coupons-bg01.png');
		background-position: top left;
		background-repeat: no-repeat;
		background-size: vw(690) vw(200);
		color: #ff9c8a;
		.left .coupon-title {
			color: #ff5232;
		}
		.right .coupon-price,
		.coupon-price1 {
			color: #ff5232;
		}
		.btn {
			border: 1px solid #ff5232;
			width: vw(118);
			height: vw(48);
			text-align: center;
			line-height: vw(48);
			border-radius: vw(24);
			color: #ff5232;
		}
	}
	.blbg {
		background-image: url('../assets/market/coupons-bg02.png');
		background-position: top left;
		background-repeat: no-repeat;
		background-size: vw(690) vw(200);
		color: #b6cfff;
		.left .coupon-title {
			color: #3377ff;
		}
		.right .coupon-price,
		.coupon-price1 {
			color: #3377ff;
		}

		.btn {
			border: 1px solid #3377ff;
			width: vw(118);
			height: vw(48);
			text-align: center;
			line-height: vw(48);
			border-radius: vw(24);
			color: #3377ff;
		}
	}

	.blbg2 {
		.left .coupon-title {
			color: #999999;
		}
		.right .coupon-price,
		.coupon-price1 {
			color: #999999;
		}

		.btn {
			border: 1px solid #999999;
			width: vw(118);
			height: vw(48);
			text-align: center;
			line-height: vw(48);
			border-radius: vw(24);
			color: #999999;
		}
	}

	.grbg {
		background-image: url('../assets/market/coupons-bg03.png');
		background-position: top left;
		background-repeat: no-repeat;
		background-size: vw(690) vw(200);
		color: #999999;
	}

	.noselect {
		color: #999999;
		.left .coupon-title {
			color: #999;
		}
		.right .coupon-price,
		.coupon-price1 {
			color: #999;
		}
		.btn {
			border: none;
			width: vw(118);
			height: vw(48);
			text-align: center;
			line-height: vw(48);
			border-radius: 0;
			color: #999;
		}
	}

	.selectbg {
		background-image: url('../assets/market/coupons-bg04.png');
	}
	.no_btn {
		position: absolute;
		bottom: 20px;
		left: 30px;
		right: 30px;
		border-radius: 4px;
		border: 1px solid #3377ff;
		height: 44px;
		background-color: white;
		line-height: 44px;
		text-align: center;
		color: #3377ff;
		font-size: 15px;
	}
}
</style>
